import * as React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Input from '../../../Input/Input';
import './RequestMail.css';
import Button from '../../../Button/Button';
import saveEmail from '../../../../requests/saveEmail';

const EMAIL_REGEX = /^([a-zA-z\.\-\d])+@([a-zA-Z\-\.\d])+$/;

interface Props {
	onClose: (success?: boolean) => void;
}

const RequestMail: React.FC<Props> = props => {
	const inputRef = React.useRef<HTMLInputElement>(null);
	const [error, setError] = React.useState('');
	const [loading, setLoading] = React.useState(false);

	const onSave = () => {
		if (inputRef.current) {
			const value = inputRef.current.value;

			if (EMAIL_REGEX.test(value)) {
				setError('');
				setLoading(true);

				saveEmail(value).then(result => {
					props.onClose(true);
				});
			}
			else {
				setError('Некорректный Email');
			}
		}
	};

	return <Dialog open={true} onClose={() => { }}>
		<div className="request-mail-wrapper">
			<div className="request-mail-header">Укажите email адрес</div>

			<div className="request-mail__subheader">
				Мы будем напоминать вам о запланированных книгах и отправлять ежемесячную статистику вашей библиотеки
			</div>

			<Input
				hiddenLabel={true}
				inputRef={inputRef}
				error={!!error}
				helperText={error}
			/>
			
			<div className="request-mail__buttons">
				<Button onClick={() => props.onClose(false)}>
					Указать позже
				</Button>

				<Button type="primary" isLoading={loading} onClick={onSave}>
					Сохранить
				</Button>
			</div>
		</div>
	</Dialog>
};

export default RequestMail;